import React, { Component } from "react";
import AddVehicle from "../AddVehicle/AddVehicle";

class EditVehicle extends Component {
  render() {
    return <AddVehicle vehicleId={this.props.match.params.id} />;
  }
}

export default EditVehicle;
